export default "__VITE_ASSET__Ze36_0d7__"